<template>
    <!-- 顶部信息 -->
    <div class="topMsg">
      <div class="box">
        <div class="left">
          <div class="left-list">
            <div class="left_title">全国服务热线：</div>
            <div class="left_content">{{ config.hotline_phone }}</div>
          </div>
        </div>
        <div class="right">
          <div class="left-list" style="cursor: pointer">
            <div class="left_title">当前：</div>
            <div class="right_content" style="margin-right: 40px;">{{ config.website_title }}</div>
          </div>
          <div class="right-list show_xcx">
            <img :src="getOnLineAssetsByPc('layout/icon_xcx.png')" alt="" />
            <div class="right_content">小程序</div>
            <div class="xcx_class">
              <img
                style="margin: 0 auto; width: 100px; height: 100px"
                :src="config.wx_mini_url"
                alt=""
              />
            </div>
          </div>
          <!-- <div style="width: 50px;"></div> -->
          <!--                <div class="right-list">-->
          <!--                    <img src="@/assets/layout/icon2.png" alt="">-->
          <!--                    <div>客服</div>-->
          <!--                </div>-->
          <!--                <div class="right-list">-->
          <!--                    <img src="@/assets/layout/icon3.png" alt="">-->
          <!--                    <div>帮助</div>-->
          <!--                </div>-->
        </div>
      </div>
    </div>
  </template>

  <script>

  import {getOnLineAssetsByPc} from "@/utils/publicMethonds";

  export default {
    props: {
      province_name: {
        type: String,
        default: "",
      },
    },
    data() {
      return {
        config: {
          address: "",
          banner: "",
          bottom_banner: "",
          copyright: "",
          domain: "",
          email: "",
          hotline_phone: "",
          icp: "",
          logo: "",
          name: "",
          phone: "",
          website_title: "",
          wx_mini_url: "",
          wx_offiaccount_url: "",
        },
      };
    },
    created() {
      this.config = this.getGlobalConfig()
    },
    methods: {
      getOnLineAssetsByPc
    },
  };
  </script>

  <style lang="scss" scoped>
  @import "@/style/var.scss";

  .topMsg {
    width: 100%;
    height: 30px;
    background: #eaeaea;

    .box {
      width: 1230px;
      height: 30px;
      margin: 0 auto;
      background-size: 100% 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
      line-height: 30px;
      color: #ffffff;

      .left,
      .right {
        display: flex;
        align-content: center;

        .left-list {
          display: flex;
          height: 16px;
          line-height: 16px;
          // margin-left: 20px;
        }

        .right-list {
          display: flex;
          align-items: center;
          height: 16px;
          line-height: 16px;
          // margin-right: 20px;
          // padding-right: 20px;
          cursor: pointer;
          //border-right: 1px solid #ff8d74;

          &:nth-of-type(3) {
            margin-right: 0px;
            border: 0;
            padding: 0;
          }

          img {
            width: 14px;
            height: 14px;
            margin-right: 8px;
          }
        }
      }
    }
  }

  .show_xcx {
  }

  .show_xcx:hover .xcx_class {
    display: flex;
  }

  .left_title {
    color: #999999;
  }

  .left_content {
    color: #ff1818;
  }

  .right_content {
    color: #333333;
  }
  .xcx_class {
    position: absolute;
    top: 35px;
    width: 110px;
    height: 110px;
    background-color: var(--main-bg);
    display: none;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    border-radius: 5px;
    z-index: 999999;
  }
  </style>
